// extracted by css-extract-rspack-plugin
export default {"chatWrap":"chatWrap-QFbKCB","chatAideList":"chatAideList-JAMKOR"};